import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import summaryList from '@/types/table/summaryList';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface SummaryListData extends summaryList {
    __cascade_add_temp_id__?: string | number | undefined;
}

export default class SummaryListController extends BaseController {
    static listPage(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post<TableData<SummaryListData>>(API_CONTEXT + '/app/summaryList/listPage', params, httpOptions);
    }

    static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post<TableData<SummaryListData>>(API_CONTEXT + '/app/summaryList/list', params, httpOptions);
    }
    static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.get<SummaryListData>(API_CONTEXT + '/app/summaryList/view', params, httpOptions);
    }
    static export(params: ANY_OBJECT, fileName: string) {
        return super.download(API_CONTEXT + '/app/summaryList/export', params, fileName);
    }

    static exportDetail(params: ANY_OBJECT, fileName: string) {
        return super.download(API_CONTEXT + '/app/summaryList/exportDetail', params, fileName);
    }


    static listPageDetail(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return  super.post<TableData<SummaryListData>>(API_CONTEXT + '/app/summaryList/listPageDetail', params, httpOptions);
    }


    static import(params: ANY_OBJECT) {
        return super.upload(API_CONTEXT + '/app/summaryList/import', params);
    }
    static printUrl(params: ANY_OBJECT) {
        return buildGetUrl(API_CONTEXT + '/app/summaryList/print', params);
    }
    static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post(API_CONTEXT + '/app/summaryList/add', params, httpOptions);
    }
    static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post(API_CONTEXT + '/app/summaryList/update', params, httpOptions);
    }
    static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post(API_CONTEXT + '/app/summaryList/delete', params, httpOptions);
    }
    static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
        return super.post(API_CONTEXT + '/app/summaryList/deleteBatch', params, httpOptions);
    }
}
